export default __webpack_public_path__ + "static/media/21.20e95731.jpeg";